import { BranchPinsService } from '@/backend/market'
import { BranchPinRepository } from '../../domain/repositories/BranchPinRepository'
import { BranchPinModel } from '../models/BranchPinModel'
import type { BranchPinFilterEntity } from '../../domain/entities/BranchPinFilterEntity'
import { BranchPinFilterModel } from '../models/BranchPinFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class BranchPinRepositoryImpl implements BranchPinRepository {
  async getBranchPins(
    filterData: BranchPinFilterEntity
  ): Promise<PaginateEntity<BranchPinModel[]> | { error: true }> {
    const filterModel = new BranchPinFilterModel(filterData)
    try {
      const response = await BranchPinsService.getBranchPinsAdmin(filterModel)
      const branchPinModels = response.items?.map((item) => new BranchPinModel(item))
      const branchPinResponse = new PaginateEntity<BranchPinModel[]>(response, branchPinModels)

      return branchPinResponse
    } catch {
      return { error: true }
    }
  }
  async createBranchPin({
    branch,
    order
  }: {
    branch: BranchMiniEntity
    order: number
  }): Promise<{ success: true } | { error: true }> {
    try {
      await BranchPinsService.postBranchPinAdmin({
        requestBody: {
          branchId: branch.id!,
          order: order
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async orderBranchPin(id: number, order: number): Promise<{ success: true } | { error: true }> {
    try {
      await BranchPinsService.putBranchPinAdmin({
        id,
        requestBody: {
          order: order
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteBranchPin(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await BranchPinsService.deleteBranchPinAdmin({
        id
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
